import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "\u5373\u65F6\u6D88\u606F\u901A\u77E5"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M12.0112 2.34937C6.4317 2.34937 1.94019 6.27888 1.94019 11.1233C1.94019 14.1064 3.65991 16.7388 6.25635 18.3529V21.055C6.25635 21.4057 6.50139 21.6507 6.81836 21.6507C6.92401 21.6507 7.02967 21.6148 7.09936 21.581L9.83518 19.7557C10.5366 19.895 11.2379 19.931 11.9753 19.931C17.5571 19.931 22.0486 16.0015 22.0486 11.157C22.0823 6.27888 17.5571 2.34937 12.0112 2.34937ZM7.48377 12.5621C6.81611 12.5621 6.29007 12.0001 6.29007 11.3684C6.29007 10.7007 6.85208 10.1747 7.48377 10.1747C8.15142 10.1747 8.67746 10.7367 8.67746 11.3684C8.71118 12.0001 8.15142 12.5621 7.48377 12.5621ZM12.0809 12.5621C11.4133 12.5621 10.8872 12.0001 10.8872 11.3684C10.8872 10.7007 11.4492 10.1747 12.0809 10.1747C12.7486 10.1747 13.2746 10.7367 13.2746 11.3684C13.2746 12.0001 12.7126 12.5621 12.0809 12.5621ZM16.5028 12.5621C15.8351 12.5621 15.3091 12.0001 15.3091 11.3684C15.3091 10.7007 15.8711 10.1747 16.5028 10.1747C17.1704 10.1747 17.6965 10.7367 17.6965 11.3684C17.6965 12.0001 17.1704 12.5621 16.5028 12.5621Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var ______ = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { ______ as default };
